import { Box } from '@mui/system';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { IoMdAdd } from 'react-icons/io';
import {
  CustomButton,
  SubmitButton,
} from '../../../components/common/button/CustomButtons';
import ChildHeader from '../../../components/ui/ChildHeader';
import { useQuery } from '../../../hooks/UseQuery';
import { useAuth } from '../../../services/auth/AuthProvider';
import useConfirm from '../../../components/common/useConfirm';
import { Loader } from '../../../components/common/Loader';
import { Stack } from '@mui/material';
import TController from './components/TController';
import useGetData from './helpers/useGetData';
import { apiConstant } from './helpers/constant';

interface MyData {
  moduleData: any;
  Sync: any;
  isLoading: boolean;
  error?: string | null;
  updateModuleData: any;
  addRow: any;
  handleDelete: any;
  setTriggerRender: any;
  handleSort: any;
}

const Create = () => {
  const { id } = useParams();
  const { state } = useAuth();
  const navigate = useNavigate();
  const isView = useQuery('isView') === 'true' ? true : false;
  const [DialogSave, confirmSave] = useConfirm(
    'SAVE',
    'Are you sure you want to Update this?'
  );
  const {
    moduleData,
    isLoading,
    error,
    Sync,
    updateModuleData,
    handleDelete,
    addRow,
    setTriggerRender,
    handleSort,
  }: MyData = useGetData(id);

  const onSubmit = async (isSubmitted: boolean) => {
    const isAllRowFiled = moduleData?.list?.every(
      (item: any) => item.minimum_level !== null && item.minimum_level !== ''
    );

    if (!isAllRowFiled) {
      alert(
        'Oops! It looks like some rows are still empty. Please fill in all the required fields to proceed. 🛑✍️'
      );
      return;
    }

    const ans = await confirmSave();
    if (!ans) return;

    if (id) {
      axios
        .put(`/api/${apiConstant.update}/${id}`, moduleData)
        .then((res) => {
          alert('updated successfully ');
          setTriggerRender((prev: any) => !prev);
          // navigate(-1);
        })
        .catch((err) => console.log(err));
    } else {
      axios
        .post(`/api/${apiConstant.post}`, moduleData)
        .then((res) => {
          alert('create successfully');
          // setTriggerRender((prev: any) => !prev);
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <Box>
      <Box>
        <Loader loader={isLoading} />
        <ChildHeader text="">
          {!isView && (
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={1}
              sx={{}}
            >
              <CustomButton
                sx={{
                  backgroundColor: '#228be6',
                  color: '#e7f5ff',
                }}
                icon={<IoMdAdd />}
                size="large"
                onClick={addRow}
              >
                ADD ROW
              </CustomButton>
              <SubmitButton
                label={id ? 'Update' : 'submit'}
                onClick={() => onSubmit(true)}
              />
            </Stack>
          )}
        </ChildHeader>
      </Box>
      <TController
        {...{
          handleDelete,
          moduleData,
          updateModuleData,
          handleSort,
        }}
      />
      <Sync isSubmitContent={false} />
      <DialogSave isSubmitContent={false} />
    </Box>
  );
};

export default Create;
